import { useState, useEffect } from "react";
import useAPI from "../hooks/useAPI";

export default function useAdminLogs() {
  const localUser = JSON.parse(localStorage.getItem("kdmUser"));
  const superUser = localUser?.sub === process.env.REACT_APP_ADMIN_UID;

  console.log("useAdminLogs - localUser:", localUser);
  console.log("useAdminLogs - superUser:", superUser);
  console.log(
    "useAdminLogs - REACT_APP_ADMIN_UID:",
    process.env.REACT_APP_ADMIN_UID
  );

  const [logs, setLogs] = useState("");
  const [lines, setLines] = useState(100);
  const [since, setSince] = useState("");
  const [container, setContainer] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Construire l'URL avec les paramètres
  const buildUrl = () => {
    let url = "logs"; // Pas "admin/logs" car basePath contient déjà "admin/"
    const params = [];

    if (lines && lines !== 100) {
      params.push(`lines=${lines}`);
    }

    if (since) {
      params.push(`since=${since}`);
    }

    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    console.log("buildUrl result:", url);
    return url;
  };

  const { data, query: fetchLogs } = useAPI({
    type: "get",
    url: "logs", // URL de base
    defer: true,
  });

  // Méthode pour rafraîchir les logs
  const handleRefreshLogs = async () => {
    setLoading(true);
    setError(null);
    try {
      // Passer l'URL dynamique à fetchLogs
      await fetchLogs({ url: buildUrl() });
    } catch (err) {
      console.error("Error fetching logs:", err);
      setError("Erreur lors de la récupération des logs");
    } finally {
      setLoading(false);
    }
  };

  // Méthode pour changer le nombre de lignes
  const handleLinesChange = (newLines) => {
    setLines(newLines);
    setSince(""); // Reset since when changing lines
  };

  // Méthode pour changer la période
  const handleSinceChange = (newSince) => {
    setSince(newSince);
    if (newSince) {
      setLines(null); // Reset lines when using since
    }
  };

  // Charger les logs au montage du composant
  useEffect(() => {
    handleRefreshLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lines, since]);

  // Mettre à jour les logs quand les données arrivent
  useEffect(() => {
    if (data && data.success) {
      setLogs(data.logs || "");
      setContainer(data.container || "");
    }
  }, [data]);

  return {
    logs,
    lines,
    since,
    container,
    loading,
    error,
    onRefreshLogs: handleRefreshLogs,
    onLinesChange: handleLinesChange,
    onSinceChange: handleSinceChange,
  };
}
